import {
    trigger,
    transition,
    style,
    query,
    group,
    animateChild,
    animate,
    keyframes,
} from '@angular/animations';
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

export const slideIn =
    trigger('routeAnimations', [
        transition('* <=> *', [
            query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
            group([
                query(':enter', [style({ opacity: 0 }), animate('.6s ease-out', style({ opacity: 1 }))], {
                    optional: true,
                }),
                query(':leave', [style({ opacity: 1 }), animate('.6s ease-out', style({ opacity: 0 }))], {
                    optional: true,
                }),
            ]),
        ]),
    ]);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [
        slideIn
    ]
})
export class AppComponent {
    constructor(
        private router: Router,
        private spinnerService: NgxSpinnerService,
    ) {
        router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.intervalLoadScript("/assetsAdmin/js/form.js", false, 50);
            }
        });
    }

    title = 'Angular7';

    isLogin: boolean = false;

    routeSubscription: any;
    renderCount = 0;
    oldRenderCount = 0;
    changeRenderCount = 0;
    oldChangeRenderCount = 0;

    ngOnInit() {
        if (localStorage.getItem('logged'))
            this.isLogin = true;
        this.spinnerService.show();
        this.intervalLoadScript("/assetsAdmin/js/main.js", true, 500);
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet && outlet.activatedRouteData;
    }

    ngDoCheck() {
        this.renderCount++;
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    intervalLoadScript(url, isShowLoader, timeDelay) {
        if (isShowLoader)
            document.getElementById('page-loader').style.display = "block";
        const loadScript = () => {
            this.oldRenderCount++;
            let oldChange = this.changeRenderCount;
            if (this.changeRenderCount != this.oldChangeRenderCount)
                this.oldChangeRenderCount = oldChange;
            this.changeRenderCount = this.renderCount - this.oldRenderCount;

            let res = this.changeRenderCount != this.oldChangeRenderCount || this.oldRenderCount == 0 || this.renderCount == 0;
            return res;
        };

        return new Promise(function (resolve, reject) {
            var isRunning = loadScript();

            if (isRunning) {
                var interval = setInterval(function () {
                    isRunning = loadScript();
                    if (!isRunning) {
                        clearInterval(interval);

                        let nodeMain = document.createElement('script');
                        nodeMain.src = url;
                        nodeMain.type = 'text/javascript';
                        nodeMain.async = true;
                        nodeMain.charset = 'utf-8';
                        document.getElementsByTagName('body')[0].appendChild(nodeMain);
                        if (isShowLoader)
                            document.getElementById('page-loader').style.display = "none";

                        reject();
                    }
                }, timeDelay);
            }
            else
                resolve(true);
        })
    }
}